import { getEffectiveTokenListUrl } from '../tokenList'

// Use centralized configuration to get the appropriate token list URL
// This is called at module load time, but getEffectiveTokenListUrl() handles
// environment detection correctly (server-side vs client-side)
const GRX_CHAIN_LIST = getEffectiveTokenListUrl()

// Log the URL being used (for debugging)
if (typeof window !== 'undefined') {
  // Only log on client-side to avoid build-time noise
  console.log('[Token List Config] Using URL:', GRX_CHAIN_LIST)
  if (GRX_CHAIN_LIST.includes('/api/tokenlist')) {
    console.log('[Token List Config] Mode: API Proxy (Development)')
  } else {
    console.log('[Token List Config] Mode: Direct GitHub URL (Production)')
  }
}

// List of official tokens list - only use the GitHub URL
export const OFFICIAL_LISTS = [GRX_CHAIN_LIST]

export const UNSUPPORTED_LIST_URLS: string[] = []

// lower index == higher priority for token import
export const DEFAULT_LIST_OF_LISTS: string[] = [
  GRX_CHAIN_LIST,
  ...UNSUPPORTED_LIST_URLS, // need to load unsupported tokens as well
]

// default lists to be 'active' aka searched across
export const DEFAULT_ACTIVE_LIST_URLS: string[] = [GRX_CHAIN_LIST]
